<div class="invoice-container" [attr.dir]="direction">
  <!-- البلوك الأحمر: اسم الشركة وأرقام التسجيل -->
  <div class="header">
    <div class="logo-container" *ngIf="invoiceData?.company?.logo_url || invoiceData?.logo_base64">
      <img
        [src]="invoiceData?.company?.logo_url || invoiceData?.logo_base64"
        [alt]="translateKeyLocal('invoice.logoAlt')"
      />
    </div>

    <h2
      style="font-size: 1.2em; margin: 0 0 5px 0; color: #fff; font-weight: 800"
    >
  {{ getCompanyName() || translateKeyLocal('invoice.companyNameFallback') }}
    </h2>
      <p *ngIf="invoiceData?.company && (invoiceData?.company?.vat || getCompanyVat())">
      <span
        [innerHTML]="getCompanyTypeInParentheses() ? getCompanyTypeInParentheses() + ' ' + (invoiceData?.company?.vat || getCompanyVat()) : translateKeyLocal('invoice.vatLine.company_diff', { vat: invoiceData?.company?.vat || getCompanyVat(), id: invoiceData?.company?.id || '' })"
      ></span>
    </p>
  </div>

  <!-- الشريط الجديد: اسم المستند ورقم الفاتورة (أحمر على أبيض) -->
  <div class="invoice-title-bar">
  <span class="document-title">{{ getInvoiceTypeName() || translateKeyLocal('invoice.simple') }}</span>
  <span class="document-number">{{ translateKeyLocal('documentNumber') }} {{ invoiceData?.document_number || invoiceData?.invoice_number || translateKeyLocal('invoice.defaultDocumentNumber') }}</span>
  </div>
  
  <!-- Allocation Number Display -->
  <div *ngIf="invoiceData?.confirmation_number" class="allocation-number" style="text-align: center; margin: 10px 0; font-size: 12px; color: #666;">
    <span>{{ getConfirmationNumber().remainingDigits }}<span style="text-decoration: underline;">{{ getConfirmationNumber().last9Digits }}</span></span>
  </div>

  <!-- تفاصيل الفاتورة والزبون - شريط جانبي أحمر -->
  <div class="details-box">
    <p>
  <span class="label">{{ translateKeyLocal('customerName') }}</span>
  <span>{{ getCustomerName() }}</span>
    </p>
    
    <!-- Customer VAT/ID Information -->
    <ng-container *ngIf="getCustomerVatIdLines() && getCustomerVatIdLines().length > 0">
      <div *ngFor="let vatIdLine of getCustomerVatIdLines()" style="font-weight: 500; font-size: 12px; margin: 5px 0;">
        {{ vatIdLine }}
      </div>
    </ng-container>

  <hr class="details-separator" />

    <p>
  <span class="label">{{ translateKeyLocal('invoiceDate') }}</span>
      <span>{{ getFormattedDate() }}</span>
    </p>
  </div>

  <!-- عنوان قائمة المنتجات باللون الأحمر -->
  <div class="products-title">{{ translateKeyLocal('productDetails') }}</div>

  <!-- بطاقة المنتج -->
  <div
    *ngFor="let line of invoiceData?.lines || invoiceData?.soldItems"
    class="product-card"
  >
    <div class="product-description">
      {{ line.description || line.item_name || line.product_name }}
      <span *ngIf="line.color"> - ({{ line.color }})</span>
    </div>

    <div class="line-item price-qty-row">
      <span class="item-label">{{ translateKeyLocal('priceXQuantity') }}</span>
      <span class="item-value"
        >{{ formatNumber(line.price_per_unit || line.price) }} ×
        {{ formatNumber(line.quantity) }}
        <span class="toggle-indicators">
          <span *ngIf="line.isVatIncluded" class="vat-indicator" 
                [title]="translateKeyLocal('documentLines.incVat')">
            {{ translateKeyLocal('documentLines.incVat') }}
          </span>
        </span>
      </span>
    </div>

    <div class="discount-total-row">
      <div class="discount-info">
        <span class="item-sub-label">{{ translateKeyLocal('itemDiscountTotal') }}</span>
        <span class="discount-value">{{
          line.discount
            ? (line.isPresenting === true ? (direction === 'rtl' ? "%" + formatNumber(line.discount) : formatNumber(line.discount) + "%") : formatNumber(line.discount))
            : "0.00"
        }}</span>
      </div>
      <div class="total-item-info">
        <span class="item-sub-label">{{ translateKeyLocal('subtotal') }}</span>
        <span class="subtotal-value">{{
          formatNumber(line.sub_total || line.total)
        }}</span>
      </div>
    </div>
  </div>

  <!-- Payment Details for Receipts -->
  <div class="payments" *ngIf="invoiceData?.receiptsDetails && invoiceData.receiptsDetails.length">
    <h3>{{ translateKeyLocal('paymentDetails') }}</h3>
    <table class="payment-table">
      <thead>
        <tr>
          <th>{{ translateKeyLocal('invoice.payment.method') }}</th>
          <th>{{ translateKeyLocal('dueDate') }}</th>
          <th>{{ translateKeyLocal('invoice.payment.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of invoiceData.receiptsDetails">
          <td class="method">{{ getPaymentMethodName(r.payment_type) }}</td>
          <td class="due">{{ r.date || '-' }}</td>
          <td class="amount" [ngClass]="{'deduction-amount': r.payment_type === 5 && !isReceipt()}">
            {{ formatNumber(r.amount) }}
          </td>
        </tr>
        <!-- Show deduction_from_source if it exists but not in receiptsDetails -->
        <tr *ngIf="getDeductionAmount() > 0 && !hasDeductionInReceiptsDetails()">
          <td class="method">{{ getPaymentMethodName(5) }}</td>
          <td class="due">-</td>
          <td class="amount" [ngClass]="{'deduction-amount': !isReceipt()}">
            {{ formatNumber(getDeductionAmount()) }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="label-total">{{ translateKeyLocal('totalAmountReceived') }}</td>
          <td class="amount" style="font-weight:700;">{{ formatNumber(getPaymentAmountIncludingVat()) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- ملخص المبالغ (Hidden for Receipts) -->
  <div class="products-title" *ngIf="!isReceipt()">{{ translateKeyLocal('summary') }}</div>
  <div class="total-summary" *ngIf="!isReceipt()">
    <div class="summary-row">
      <span class="summary-label">{{ translateKeyLocal('grossTotal') }}</span>
      <span class="summary-value">{{
        formatNumber(
          invoiceData?.amount_before_discount ||
            invoiceData?.total_amount_before_discount
        )
      }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">{{ translateKeyLocal('totalProductDiscounts') }}</span>
      <span class="summary-value">{{
        formatNumber(invoiceData?.all_discount)
      }}</span>
    </div>
    <div class="summary-row">
  <span class="summary-label">{{ translateKeyLocal('taxableValue') }}</span>
      <span class="summary-value">{{
        formatNumber(invoiceData?.payment_amount || invoiceData?.sub_total)
      }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">{{ translateKeyLocal('invoice.vat') }} ({{ getVatPercentage() }}%)</span>
      <span class="summary-value">{{
        formatNumber(invoiceData?.all_vat_amount)
      }}</span>
    </div>

    <div class="summary-row grand-total">
  <span class="summary-label">{{ translateKeyLocal('dueBeforeTotalDiscount') }}</span>
      <span class="summary-value">{{
        formatNumber(getPaymentAmountIncludingVat())
      }}</span>
    </div>
  </div>

  <!-- التذييل -->
  <div
    *ngIf="invoiceData?.invoice_note"
    style="text-align: center; margin-top: 20px; font-size: 0.8em; color: #777"
  >
  <p style="white-space: pre-line">{{ invoiceData?.invoice_note | formatNoteHtml }}</p>
  </div>
</div>
